
(function(){
  var wrap=document.getElementById('dv-ad-wrap-template--29158131597678__antes_despues_dv');
  var after=document.getElementById('dv-ad-after-template--29158131597678__antes_despues_dv');
  var div=document.getElementById('dv-ad-div-template--29158131597678__antes_despues_dv');
  var hdl=document.getElementById('dv-ad-hdl-template--29158131597678__antes_despues_dv');
  if(!wrap||!after||!hdl)return;
  function setPos(pct){pct=Math.min(Math.max(pct,2),98);after.style.clipPath='inset(0 '+(100-pct)+'% 0 0)';div.style.left=pct+'%';hdl.style.left=pct+'%';hdl.setAttribute('aria-valuenow',Math.round(pct));}
  setPos(50);
  var drag=false,rect=null,frame=null,pendingPct=50;
  function paint(){frame=null;setPos(pendingPct);}
  function queuePos(clientX){if(!rect)rect=wrap.getBoundingClientRect();pendingPct=(clientX-rect.left)/rect.width*100;if(!frame)frame=requestAnimationFrame(paint);}
  hdl.addEventListener('pointerdown',function(e){drag=true;rect=wrap.getBoundingClientRect();hdl.setPointerCapture(e.pointerId);queuePos(e.clientX);});
  hdl.addEventListener('pointermove',function(e){if(drag)queuePos(e.clientX);});
  hdl.addEventListener('pointerup',function(){drag=false;rect=null;});
  hdl.addEventListener('pointercancel',function(){drag=false;rect=null;});
  hdl.addEventListener('keydown',function(e){var value=parseInt(hdl.getAttribute('aria-valuenow'),10)||50;if(e.key==='ArrowLeft'||e.key==='ArrowDown'){e.preventDefault();setPos(value-2);}if(e.key==='ArrowRight'||e.key==='ArrowUp'){e.preventDefault();setPos(value+2);}if(e.key==='Home'){e.preventDefault();setPos(2);}if(e.key==='End'){e.preventDefault();setPos(98);}});
})();


(function(){
  var root=document.getElementById('beauty-card-dv-template--29158131597678__porcentaje_pp_dv');
  if(!root)return;
  var C=2*Math.PI*32;
  function animateStats(container){
    container.querySelectorAll('.bc-circle-fill').forEach(function(el){
      var pct=parseInt(el.getAttribute('data-pct'))||0;
      el.style.strokeDashoffset=C-(pct/100)*C;
    });
  }
  var statsObs=null;
  if('IntersectionObserver' in window){
    statsObs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){animateStats(e.target);statsObs.unobserve(e.target);}});
    },{threshold:0.3});
    statsObs.observe(root);
  }else{animateStats(root);}

  var vids=root.querySelectorAll('.bc-vid-el');
  function hideLogo(v){var w=v.closest('.bc-vid-wrap');if(w)w.classList.add('logo-hidden');}
  function showLogo(v){var w=v.closest('.bc-vid-wrap');if(w)w.classList.remove('logo-hidden');}
  vids.forEach(function(v){
    v.muted=true;v.setAttribute('playsinline','');v.setAttribute('webkit-playsinline','');
    v.addEventListener('loadeddata',function(){hideLogo(v);});
    v.addEventListener('playing',function(){hideLogo(v);});
    v.addEventListener('error',function(){showLogo(v);});
  });
  var reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var vidObs=null;
  function loadVideo(v){if(!v.dataset.loaded&&v.dataset.src){v.src=v.dataset.src;v.dataset.loaded='1';v.load();}}
  if('IntersectionObserver' in window){
    vidObs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var v=e.target;
        if(e.isIntersecting){loadVideo(v);if(!reducedMotion&&!document.hidden)v.play().catch(function(){});}
        else{v.pause();}
      });
    },{threshold:0.5});
    vids.forEach(function(v){vidObs.observe(v);});
  }else{vids.forEach(function(v){loadVideo(v);});}

  function onVisibility(){
    if(document.hidden){vids.forEach(function(v){v.pause();});}
  }
  document.addEventListener('visibilitychange',onVisibility);
  document.addEventListener('shopify:section:unload',function cleanup(event){
    if(event.detail.sectionId!=='template--29158131597678__porcentaje_pp_dv')return;
    statsObs?.disconnect();vidObs?.disconnect();
    vids.forEach(function(v){v.pause();});
    document.removeEventListener('visibilitychange',onVisibility);
    document.removeEventListener('shopify:section:unload',cleanup);
  });
})();


(function(){
  var el=document.getElementById('dvr-template--29158131597678__resenas_dv');
  if(!el)return;
  function showBars(){el.querySelectorAll('.dvr-bar-fill').forEach(function(b){b.style.width=b.getAttribute('data-pct')+'%';});}
  if('IntersectionObserver' in window){
    var obs=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){showBars();obs.disconnect();}});},{threshold:0.3});
    obs.observe(el);
    document.addEventListener('shopify:section:unload',function cleanup(event){if(event.detail.sectionId!=='template--29158131597678__resenas_dv')return;obs.disconnect();document.removeEventListener('shopify:section:unload',cleanup);});
  }else{showBars();}
  var track=el.querySelector('.dvr-track');
  var viewport=el.querySelector('.dvr-viewport');
  var pages=Array.prototype.slice.call(el.querySelectorAll('.dvr-page'));
  var dots=Array.prototype.slice.call(el.querySelectorAll('.dvr-dot'));
  var prev=el.querySelector('.dvr-prev');
  var next=el.querySelector('.dvr-next');
  var current=0;
  var touchStartX=0;
  var touchStartY=0;
  var touchActive=false;
  function syncHeight(){if(viewport&&pages[current])viewport.style.height=pages[current].offsetHeight+'px';}
  function goToPage(index){
    if(!track||pages.length<2)return;
    current=Math.max(0,Math.min(index,pages.length-1));
    track.style.transform='translateX(-'+(current*100)+'%)';
    pages.forEach(function(page,i){page.setAttribute('aria-hidden',i===current?'false':'true');});
    dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===current);if(i===current){dot.setAttribute('aria-current','true');}else{dot.removeAttribute('aria-current');}});
    if(prev)prev.disabled=current===0;
    if(next)next.disabled=current===pages.length-1;
    syncHeight();
  }
  if(prev)prev.addEventListener('click',function(){goToPage(current-1);});
  if(next)next.addEventListener('click',function(){goToPage(current+1);});
  dots.forEach(function(dot){dot.addEventListener('click',function(){goToPage(Number(dot.getAttribute('data-page')));});});
  function onTouchStart(event){
    if(window.innerWidth>760||pages.length<2||event.touches.length!==1)return;
    touchStartX=event.touches[0].clientX;
    touchStartY=event.touches[0].clientY;
    touchActive=true;
  }
  function onTouchEnd(event){
    if(!touchActive||window.innerWidth>760||pages.length<2||!event.changedTouches.length)return;
    touchActive=false;
    var deltaX=event.changedTouches[0].clientX-touchStartX;
    var deltaY=event.changedTouches[0].clientY-touchStartY;
    var threshold=Math.min(50,viewport.offsetWidth*0.1);
    if(Math.abs(deltaX)<threshold||Math.abs(deltaX)<=Math.abs(deltaY)*1.2)return;
    goToPage(current+(deltaX<0?1:-1));
  }
  function onTouchCancel(){touchActive=false;}
  if(viewport){viewport.addEventListener('touchstart',onTouchStart,{passive:true});viewport.addEventListener('touchend',onTouchEnd,{passive:true});viewport.addEventListener('touchcancel',onTouchCancel,{passive:true});}
  goToPage(0);
  window.addEventListener('resize',syncHeight);
  document.addEventListener('shopify:section:unload',function cleanupCarousel(event){if(event.detail.sectionId!=='template--29158131597678__resenas_dv')return;window.removeEventListener('resize',syncHeight);if(viewport){viewport.removeEventListener('touchstart',onTouchStart);viewport.removeEventListener('touchend',onTouchEnd);viewport.removeEventListener('touchcancel',onTouchCancel);}document.removeEventListener('shopify:section:unload',cleanupCarousel);});
})();

(function(){
const root=document.querySelector('.dep-landing');if(!root)return;
const image=root.querySelector('#dep-main-image');
root.querySelectorAll('[data-dep-img]').forEach(button=>button.addEventListener('click',()=>{image.src=button.dataset.depImg;root.querySelectorAll('[data-dep-img]').forEach(b=>{b.classList.toggle('active',b===button);b.setAttribute('aria-pressed',String(b===button));});}));
function order(event){event.preventDefault();const b=document.querySelector('[data-dep-native-cod] ._rsi-buy-now-button');if(b){root.querySelector('.dep-status').textContent='';b.click();}else{root.querySelector('.dep-status').textContent='El formulario de pedido se está cargando. Intenta de nuevo en unos segundos.';}}
root.querySelectorAll('[data-dep-order],a[href="#Comprar"]').forEach(b=>b.addEventListener('click',order));
})();
